import { createApi } from "@reduxjs/toolkit/query/react";
import * as config from "config";
import * as utils from "utils";

const baseQuery = async (args, api, extraOptions) => {
  try {
    const response = await utils.authenticatedFetch(
      config.endpoints.docGen(args.url),
      args.payload || {}
    );
    return {
      data: await response.json(),
    };
  } catch (e) {
    return {
      error: String(e),
    };
  }
};

export const generatedDocumentsApi = createApi({
  reducerPath: "generatedDocumentsApi",
  baseQuery: baseQuery,
  tagTypes: ["GeneratedDocuments"],
  endpoints: (builder) => ({
    listGeneratedDocuments: builder.query({
      query: ({ submissionId, layerId }) => ({
        url: "list-generated-documents",
        payload: {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            submissionId,
            layerId,
          }),
        },
      }),
      providesTags: (result, error, { submissionId, layerId }) =>
        layerId
          ? [{ type: "GeneratedDocuments", id: `${submissionId}-${layerId}` }]
          : [{ type: "GeneratedDocuments", id: submissionId }],
    }),
    saveGeneratedDocument: builder.mutation({
      query: ({ submissionId, layerId, document }) => ({
        url: "save-generated-document",
        payload: {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            submissionId,
            layerId,
            document,
          }),
        },
      }),
      invalidatesTags: (result, error, { submissionId, layerId }) => [
        { type: "GeneratedDocuments", id: `${submissionId}-${layerId}` },
        { type: "GeneratedDocuments", id: submissionId },
      ],
    }),
    deleteGeneratedDocument: builder.mutation({
      query: ({ submissionId, layerId, documentId }) => ({
        url: "delete-generated-document",
        payload: {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            submissionId,
            layerId,
            documentId,
          }),
        },
      }),
      invalidatesTags: (result, error, { submissionId, layerId }) => [
        { type: "GeneratedDocuments", id: `${submissionId}-${layerId}` },
        { type: "GeneratedDocuments", id: submissionId },
      ],
    }),
  }),
});

export const {
  useListGeneratedDocumentsQuery,
  useSaveGeneratedDocumentMutation,
  useDeleteGeneratedDocumentMutation,
} = generatedDocumentsApi;
